import { render, staticRenderFns } from "./ColReqProductGroup.vue?vue&type=template&id=05b4bcf3&"
import script from "./ColReqProductGroup.vue?vue&type=script&lang=ts&"
export * from "./ColReqProductGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports